/**
 * NAVIGATION.JS
 *
 * Initialization and control for the header menu on desktop and mobile.
 */

import * as GLOBALS from '../globals';
import InitHighlightedNavigation from "./navigation-highlight";
import Toggle from "../classes/toggle";
import Slideable from '../classes/slideable';

/**
 * @return {boolean} successful?
 */
export default function InitHeadermenu() {
	const headermenu = document.querySelector('.headermenu');

	if (headermenu === null)
		return;

	const navigationList = headermenu.querySelector('nav');

	if (navigationList === null || navigationList.childElementCount === 0)
		return;

	InitHamburgerMenu(headermenu);

	if (GLOBALS.ENABLE_DROPDOWN_MENU) {
		InitDropdownMenu(headermenu);
	}

	if (GLOBALS.ENABLE_HIGHLIGHTED_NAVIGATION) {
		InitHighlightedNavigation(navigationList);
	}

	if (GLOBALS.ENABLE_TRANSPARENT_HEADER) {
		InitTransparentHeader(headermenu);
	}

	InitSubNav();

	return true;
}

/**
 * Initializes the mobile hamburger menu button to toggle between open/closed.
 *
 * @return {boolean} successful?
 */
function InitHamburgerMenu(headermenu) {
	const element = headermenu.querySelector('button[aria-label~="Hamburger"]');
	const slideDuration = 300;

	if (element === null)
		return;

	const slideableNavigationList = new Slideable(headermenu.querySelector('nav'), slideDuration);
	const toggle = new Toggle(element, () => {
		slideableNavigationList.toggle();

		if(toggle.pressed() === 'true')
			headermenu.classList.add('nav-expanded');
		else {
			setTimeout(() => {
				headermenu.classList.remove('nav-expanded');
			}, slideDuration);
		}
	});
}

/**
 * Initializes the mobile dropdown menu buttons to toggle between open/closed.
 *
 * @return {boolean} successful?
 */
function InitDropdownMenu(headermenu) {
	const elements = headermenu.querySelectorAll('.nav-item.has-children');

	if (elements.length === 0)
		return;

	elements.forEach((navItem) => {
		var dropdown = new Slideable(navItem.querySelector('.dropdown'));
		var button = navItem.querySelector('button');
		if(button) {
			new Toggle(navItem.querySelector('button'), () => {
				dropdown.toggle();
			});
		}
	});
}

/**
 * Initializes the functionality for the header menu to be transparent at the top of the page and get opaque once the user scrolled down a bit
 * 
 * @param {Element} headermenu 
 */
function InitTransparentHeader(headermenu) {

	if(!headermenu.classList.contains('headermenu-transparent'))
		return;

	var onScroll = function(){
		let scrollTop = document.documentElement.scrollTop;

		if(scrollTop > window.innerHeight * 1/3) {
			headermenu.classList.remove('headermenu-transparent');
		} else headermenu.classList.add('headermenu-transparent');
    };
	window.onscroll = onScroll;
	onScroll();
}

function InitSubNav() {
	const subNav = document.querySelector('#sub-nav');
	if(!subNav) return;

	const activeNavItem = subNav.querySelector('.active');
	if(!activeNavItem) return;

	subNav.scrollLeft = activeNavItem.offsetLeft;
}